import { Skeleton } from "antd";

// Shared loading view. Mirrors the page: an optional toolbar row, then summary cards, then the table or list.
export default function LoadingState({ rows = 5, cards = 0, toolbar = false, style }) {
  return (
    <div
      aria-busy="true"
      aria-live="polite"
      style={{
        padding: "24px",
        ...style,
      }}
    >
      {toolbar && (
        <div style={{ display: "flex", gap: 16, marginBottom: 24 }}>
          <div style={{ flex: "0 0 75%" }}>
            <Skeleton.Input active block style={{ height: 40 }} />
          </div>
          <div style={{ flex: 1 }}>
            <Skeleton.Button active block style={{ height: 40 }} />
          </div>
        </div>
      )}
      {cards > 0 && (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: `repeat(${cards}, minmax(0, 1fr))`,
            gap: 16,
            marginBottom: 24,
          }}
        >
          {Array.from({ length: cards }, (_, index) => (
            <div
              key={index}
              style={{
                background: "#fff",
                border: "1px solid #e5e8ee",
                borderRadius: 12,
                padding: 16,
              }}
            >
              <Skeleton active title={false} paragraph={{ rows: 2 }} />
            </div>
          ))}
        </div>
      )}
      <div style={{ background: "#fff", padding: 24, borderRadius: 12 }}>
        <Skeleton active title={false} paragraph={{ rows }} />
      </div>
    </div>
  );
}
